import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

// Build a src URL that carries the JWT for /api/files/... references
export function withAuth(url) {
  if (!url) return url;
  if (url.startsWith("data:") || url.startsWith("http")) return url;
  const token = localStorage.getItem("wk_token");
  const base = process.env.REACT_APP_BACKEND_URL || "";
  const abs = url.startsWith("/") ? `${base}${url}` : url;
  return token ? `${abs}${abs.includes("?") ? "&" : "?"}auth=${encodeURIComponent(token)}` : abs;
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshOrg = useCallback(async () => {
    try {
      const r = await api.get("/organization");
      setOrg(r.data);
      return r.data;
    } catch {
      setOrg(null);
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    const token = localStorage.getItem("wk_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then(async (r) => { setUser(r.data); await refreshOrg(); })
      .catch(() => localStorage.removeItem("wk_token"))
      .finally(() => setLoading(false));
  }, [refreshOrg]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("wk_token", r.data.token);
    setUser(r.data.user);
    await refreshOrg();
    return r.data.user;
  };

  const hydrateSession = async (token, u) => {
    localStorage.setItem("wk_token", token);
    setUser(u);
    setLoading(false);
    await refreshOrg();
  };

  const logout = () => {
    localStorage.removeItem("wk_token");
    setUser(null); setOrg(null);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, org, loading, login, logout, hydrateSession, setUser, refreshOrg }}>
      {children}
    </AuthCtx.Provider>
  );
}
